import {onDomReady} from "./observer.js";



class ageSlider {
  constructor() {
    this.options = {};

    this.elements = {
      fromSlider: document.querySelector('[data-from-age-vip]'), // fromCarret
      toSlider: document.querySelector('[data-to-age-vip]'), // line + toCarret
      fromInput: document.querySelector('[data-from-age-input-vip]'),
      toInput: document.querySelector('[data-to-age-input-vip]'),
      ageRadios: document.querySelectorAll('[data-ages-vip] > input[data-ages-from-vip]'),
      colorSlider: '#C6C6C6',
      colorRange: '#2C8A91',
    };

    this.init();
  }


  fillSlider() { // fill slider line with color from min to max selected range
    const rangeDistance = this.elements.toSlider.max - this.elements.toSlider.min;
    const fromPosition = this.elements.fromSlider.value - this.elements.toSlider.min;
    const toPosition = this.elements.toSlider.value - this.elements.toSlider.min;

    this.elements.toSlider.style.background = `linear-gradient(
      to right,
      ${this.elements.colorSlider} 0%,
      ${this.elements.colorSlider} ${(fromPosition) / (rangeDistance) * 100}%,
      ${this.elements.colorRange} ${((fromPosition) / (rangeDistance)) * 100}%,
      ${this.elements.colorRange} ${(toPosition) / (rangeDistance) * 100}%, 
      ${this.elements.colorSlider} ${(toPosition) / (rangeDistance) * 100}%, 
      ${this.elements.colorSlider} 100%)`;
  }

  fromSliderMove() {
    if (this.elements.fromSlider.value > this.elements.toSlider.value)
      this.elements.fromSlider.value = this.elements.toSlider.value; // if carrets are crossed
    this.fillSlider();
    if (this.elements.fromInput) this.elements.fromInput.value = this.elements.fromSlider.value;
    this.uncheckAllRadios();
  }

  toSliderMove() {
    if (this.elements.fromSlider.value > this.elements.toSlider.value)
      this.elements.toSlider.value = this.elements.fromSlider.value;

    if (this.elements.toSlider.value === this.elements.fromSlider.value)
      this.elements.fromSlider.classList.add('_inactive'); // toCarret on top
    else
      this.elements.fromSlider.classList.remove('_inactive'); // toCarret on bottom

    this.fillSlider();
    if (this.elements.toInput) this.elements.toInput.value = this.elements.toSlider.value;
    this.uncheckAllRadios();
  }

  fromInputChange() {
    let $fromInput = parseInt(this.elements.fromInput.value);
    if ($fromInput < this.elements.fromSlider.min) $fromInput = this.elements.fromSlider.min;
    if ($fromInput > this.elements.fromSlider.max) $fromInput = this.elements.fromSlider.max;
    if ($fromInput > this.elements.toSlider.value) {
      this.elements.toSlider.value = $fromInput;
      this.toSliderMove();
    }
    this.elements.fromSlider.value = $fromInput;
    this.fromSliderMove();
  }

  toInputChange() {
    let $toInput = parseInt(this.elements.toInput.value);
    if ($toInput < this.elements.toSlider.min) $toInput = this.elements.toSlider.min;
    if ($toInput > this.elements.toSlider.max) $toInput = this.elements.toSlider.max;
    if ($toInput < this.elements.fromSlider.value) {
      this.elements.fromSlider.value = $toInput;
      this.fromSliderMove();
    }
    this.elements.toSlider.value = $toInput;
    this.toSliderMove();
  }

  uncheckAllRadios() {
    this.elements.ageRadios.forEach(radio => {
      radio.checked = false;
    });
  }






  init() {

    if (this.elements.fromSlider &&
        this.elements.toSlider) {
      this.fillSlider();

      this.elements.fromSlider.oninput = () => this.fromSliderMove();
      this.elements.toSlider.oninput = () => this.toSliderMove();


      if (this.elements.fromInput &&
          this.elements.toInput) {
        this.elements.fromInput.onchange = () => this.fromInputChange();
        this.elements.toInput.onchange = () => this.toInputChange();
      }
      if (this.elements.ageRadios) {
        this.elements.ageRadios.forEach(radio => {
          radio.addEventListener('click', () => {
            if (radio.checked) {
              this.elements.fromSlider.value = radio.getAttribute('data-ages-from-vip');
              if (this.elements.fromInput) this.elements.fromInput.value = this.elements.fromSlider.value;
              this.elements.toSlider.value = radio.getAttribute('data-ages-to-vip');
              if (this.elements.toInput) this.elements.toInput.value = this.elements.toSlider.value;
              this.fillSlider();
            }
          });
        });
      }
    }

  }



}

onDomReady(() => {
  const header = new ageSlider();
}, false);












// fromInput.addEventListener('input', uncheckAllRadios);
// toInput.addEventListener('input', uncheckAllRadios);
//


